// extracted by mini-css-extract-plugin
export var figureCaption = "image-slice-module--figure-caption--3e6e0";
export var figureWrapper = "image-slice-module--figure-wrapper--a48ab";